<template>
    <ThankYouComp></ThankYouComp>
</template>

<script>
import ThankYouComp from '../../components/Thankyou/ThankYou.vue';

export default {
  name: "New Fee Schedule 2025",
  components: { ThankYouComp },
  computed: {},
  mounted() {},
};
</script>